import React from 'react'
import { Box, Button, Paper } from '@mui/material'
import { CarRental, Message, Share, ShoppingCart, } from '@mui/icons-material'

const Main = () => {
  const posts = [

    {
      id: 121,
      title: 'Luxury Car',
      subtitle: 'Bently Continental GT',
      image: 'https://media.autoexpress.co.uk/image/private/s--kMGIWyBb--/v1562247430/autoexpress/2019/03/bentley-continental-gt-v8-2.jpg',
      date: '06/12/2024',
      price: '$385,200.00',
      purchase: 'Order Now',

    },
    {
      id: 1,
      title: 'SUV Car',
      subtitle: 'Cadillac Excalade',
      image: 'https://th.bing.com/th/id/R.6f012a70628643a91e6314cf28f8dca3?rik=gAJhMUJVvyhCgA&pid=ImgRaw&r=0',
      date: '06/12/2024',
      price: '$108,000.00',
      purchase: 'Order Now',

    },
    {
      id: 2,
      title: 'SUV Car',
      subtitle: 'Cadillac Excalade Bullet Proof',
      image: 'https://th.bing.com/th/id/R.80edcbebc2eb2aeea640d6ed80c738f2?rik=jKpPWa9NfcT%2fQA&pid=ImgRaw&r=0',
      date: '06/12/2024',
      price: '$148,000.00',
      purchase: 'Order Now',

    },
    {
      id: 3,
      title: 'Sport Car',
      subtitle: 'Lamborghini Revuelto',
      image: 'https://th.bing.com/th/id/OIP.d-xoEkg5GqmtB6KEjxDC8QHaFj?rs=1&pid=ImgDetMain',
      date: '06/12/2024',
      price: '$608,350.00',
      purchase: 'Order Now',

    },
    {
      id: 4,
      title: 'Sport Car',
      subtitle: 'Buggati Bolide',
      image: 'https://th.bing.com/th/id/R.b490d22ad46256ec1320081baacc0561?rik=N8opGvHKAvKEAg&pid=ImgRaw&r=0',
      date: '06/12/2024',
      price: '$4,000,000.00',
      purchase: 'Order Now',

    },

    {
      id: 6,
      title: 'Sport Car',
      subtitle: 'Koenigsegg Jesko 2020',
      image: 'https://acnews.blob.core.windows.net/imgnews/large/NAZ_73328105bb4f435c851d63e534a11f07.jpg',
      date: '06/12/2024',
      price: '$3,000,000.00',
      purchase: 'Order Now',

    },


    {
      id: 9,
      title: 'Sport Car',
      subtitle: 'White Koenigsegg Agera',
      image: 'https://www.liveenhanced.com/wp-content/uploads/2020/03/Koenigsegg-Agera-RS-4.jpg',
      date: '06/12/2024',
      price: '$2,000,000.00',
      purchase: 'Order Now',

    },
    {
      id: 10,
      title: 'Luxury Car',
      subtitle: 'Maybach Truck',
      image: 'https://cdn.motor1.com/images/mgl/WR3X1/s1/mercedes-maybach-gls-2020.webp',
      date: '06/12/2024',
      price: '$205,200.00',
      purchase: 'Order Now',

    },
    {
      id: 11,
      title: 'Luxury Car',
      subtitle: '2023 Bently Recalls',
      image: 'https://media.ed.edmunds-media.com/bentley/bentayga/2023/oem/2023_bentley_bentayga_4dr-suv_azure-hybrid_fq_oem_1_1600.jpg',
      date: '06/12/2024',
      price: '$185,200.00',
      purchase: 'Order Now',

    },
    {
      id: 12,
      title: 'Luxury Car',
      subtitle: 'Bently Continental GT',
      image: 'https://media.autoexpress.co.uk/image/private/s--kMGIWyBb--/v1562247430/autoexpress/2019/03/bentley-continental-gt-v8-2.jpg',
      date: '06/12/2024',
      price: '$385,200.00',
      purchase: 'Order Now',

    },

  ]



  return (
    <Box p={1} >

      {posts.map((p) => (<Paper key={p.id} elevation={3} sx={{ padding: 1, margin: 1, borderTop: 3, borderTopColor: '#302E2EFF' }}>
        <h6 style={{ fontSize: 14, fontWeight: 'bold', color: '#302E2EFF' }}>{p.title}</h6>
        <h6 style={{ fontSize: 14, fontWeight: 'bold', color: '#302E2EFF' }}>{p.subtitle}</h6>
        <div style={{ backgroundColor: '#302E2EFF' }}>
          <img alt='' src={p.image} width={'100%'} height={210} />
          {/* <video src={p.image} width={'100%'} height={210}></video> */}
        </div>
        <h6 style={{ fontSize: 14, color: '#302E2EFF' }}>Opened On: {p.date}</h6>
        <h6 style={{ fontSize: 14, color: '#302E2EFF' }}>Price: {p.price}</h6>
        {/* <h6 style={{ fontSize: 14, color: '#302E2EFF' }}>Discount: 10.0%</h6> */}
        <Button startIcon={<CarRental />} sx={{ margin: 1, display: 'flex' }} href='https://t.me/direct_manager010' color='#302E2EFF' variant='contained' size='small'>See more about this car</Button>

        <div>
          <h6 style={{ color: '#302E2EFF' }}> &trade; {p.purchase}</h6>
          <Button sx={{ margin: 1 }} href='https://t.me/direct_manager010' startIcon={<ShoppingCart />} color='#302E2EFF' variant='contained' size='small'>Buy</Button>
          <Button sx={{ margin: 1 }} href='https://t.me/direct_manager010' startIcon={<Message />} color='#302E2EFF' variant='contained' size='small'>Chat</Button>
          <Button sx={{ margin: 1 }} href='https://t.me/direct_manager010' startIcon={<Share />} color='#302E2EFF' variant='contained' size='small'>Share</Button>
        </div>
      </Paper>))}+
    </Box>
  )
}

export default Main
